var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 95 95",
    xmlSpace: "preserve",
    viewBox: "6.43 13.62 82.15 67.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.159,56.773c-2.615,0-4.733,2.119-4.733,4.733v15.142c0,2.613,2.118,4.733,4.733,4.733c2.612,0,4.731-2.12,4.731-4.733   V61.507C15.891,58.893,13.771,56.773,11.159,56.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.33,36.332c-2.615,0-4.733,2.118-4.733,4.733v35.583c0,2.613,2.118,4.733,4.733,4.733c2.613,0,4.731-2.12,4.731-4.733   V41.065C34.062,38.45,31.943,36.332,29.33,36.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.501,47.688c-2.615,0-4.733,2.118-4.733,4.733v24.227c0,2.613,2.118,4.733,4.733,4.733c2.613,0,4.731-2.12,4.731-4.733   V52.422C52.232,49.807,50.114,47.688,47.501,47.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.672,13.618c-2.614,0-4.733,2.118-4.733,4.733v58.297c0,2.613,2.119,4.733,4.733,4.733c2.613,0,4.731-2.12,4.731-4.733   V18.352C70.403,15.736,68.285,13.618,65.672,13.618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.843,34.061c-2.615,0-4.733,2.118-4.733,4.733v37.854c0,2.613,2.118,4.733,4.733,4.733c2.613,0,4.731-2.12,4.731-4.733   V38.794C88.574,36.179,86.456,34.061,83.843,34.061z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.5e597f503e8b6591aa2c1a69e79eada6.svg";
export { ForwardRef as ReactComponent };